import Api from './api.js'
import Apiv3 from './apiv3.js'

export const getProducts = async (
  loja_id,
  search = '',
  limit = 5,
  offset = 0,
  page = 1,
  category = null,
  subcategory = null,
  except = null,
  offers = null
) => {
  const resp = await Apiv3.get('/shop/produtos', {
    params: { loja_id, search, offset, limit, page, category, subcategory, except, offers },
  })
  return resp
}

export const showProduct = async (id, loja_id) => {
  const resp = await Api.get(`/product/${id}`, { params: { loja_id } })
  return resp
}

export const featuredProduct = async () => {
  const resp = await Api.get(`/product/featured`)
  return resp
}
